var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11396_138564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2449 14.8665L15.9136 7.53908L15.4222 7.04768C15.3103 6.93645 15.1588 6.87402 15.001 6.87402C14.8432 6.87402 14.6918 6.93645 14.5798 7.04768L6.75717 14.8665C6.64244 14.9808 6.55176 15.1169 6.4905 15.2668C6.42924 15.4167 6.39862 15.5774 6.40047 15.7393C6.40806 16.4072 6.96397 16.9403 7.63183 16.9403H8.43819V23.1199H21.5639V16.9403H22.3873C22.7117 16.9403 23.0172 16.8132 23.2468 16.5836C23.3598 16.4709 23.4494 16.3369 23.5103 16.1894C23.5712 16.0419 23.6022 15.8837 23.6016 15.7241C23.6016 15.4016 23.4745 15.0961 23.2449 14.8665ZM16.0635 21.7538H13.9385V17.8833H16.0635V21.7538ZM20.1978 15.5742V21.7538H17.2778V17.4279C17.2778 17.0086 16.9382 16.669 16.5189 16.669H13.4832C13.0639 16.669 12.7242 17.0086 12.7242 17.4279V21.7538H9.80426V15.5742H7.98284L15.0029 8.55984L15.4412 8.99812L22.0211 15.5742H20.1978Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11396_138564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e09a3e930801ee856f68fd6d78103193.svg";
export { ForwardRef as ReactComponent };